import React, { useEffect, useState } from 'react';
import './Home.css'
import NavDock from '../Components/Layout/NavDock';
import ContentCardLeft from '../Components/Layout/ContentCardLeft';
import ContetCardRight from '../Components/Layout/ContentCardRight';
import MapCard from '../Components/Layout/MapCard';
import { Link } from 'react-router-dom';

import Curve from '../Assets/Icons/Curve.svg'
import { supabase } from '../supabase';



const Home = () => {

    const [myBooking, setMyBooking] = useState([]);

    useEffect(() => {
        const fetchMyBooking = async () => {
            const { data } = await supabase
                .from('bookings')
                .select(`
                    id,
                    booking_date,
                    users (first_name, last_name)
                `)
                .limit(1); // Just get the latest one
            setMyBooking(data);
        };
        fetchMyBooking();
    }, []);

    return ( 
        <main className='Home'>
            <div className='TopBar'></div>
                <div className='MainContent'>
                    
                    <ContentCardLeft CountTitle='Time until Event' TimerText='12 Days : 9 HOURS : 10 MINS : 24 SECS'/>
                    
                    <ContetCardRight 
                        TempText="Register now to secure your ticket and join the event!" 
                        bookingData={myBooking} 
                    />
                    
                    <Link className='MapLink' to={'/map'}>
                        <MapCard />
                    </Link>
                    
                </div>
            <NavDock Curve={Curve} NotchClass='NotchCurve'/>
        </main>
     );
}
 
export default Home;